import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../styles/fonts/Sohne-Buch.woff2%22,%22weight%22:%22400%22},{%22path%22:%22../styles/fonts/Sohne-Kraftig.woff2%22,%22weight%22:%22500%22},{%22path%22:%22../styles/fonts/Sohne-Halbfett.woff2%22,%22weight%22:%22600%22},{%22path%22:%22../styles/fonts/Sohne-Dreiviertelfett.woff2%22,%22weight%22:%22700%22}],%22display%22:%22swap%22}],%22variableName%22:%22sohne%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'sohne', 'sohne Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
